import React, { Component } from 'react'
import "./Logos.scss"

export default class Logos extends Component {
    static defaultProps = {
        logosOne: [
            "html",
            "css",
            "javascript",
            "react",
            "angular"
        ]
    }
    render() {
        const logos = this.props.logosOne.map((logo, index) => {
            let logosrc = `./imgs/${logo}.png`;
            return (<div className="col-12 col-md-2 my-5"><img className="Logo" src={logosrc} alt={logo} /></div>)
        })
        return (
            <div>
                <div className="row my-5 justify-content-center">
                    {logos}
                </div>
            </div>
        )
    }
}
